// Open antwoorden onder elkaar, voor een live rapportage.
//
// Nodig omdat OpenQuestionSlider één antwoord tegelijk toont met pijltjes:
// prima op een dashboard, maar wie een gedeelde rapportage leest wil alle
// antwoorden zien zonder door te klikken (updateverzoek Drenthe beweegt,
// 2026-10-02).

/**
 * @typedef {object} OpenAnswerGroup
 * @property {string} name - Naam van het meetmoment
 * @property {number|null} position - Positie van het meetmoment
 * @property {Array<{Input?: string, ID?: string, docid?: string}>} items - Antwoorden, oudste eerst
 */

/**
 * @param {object} props
 * @param {OpenAnswerGroup[]} props.groups - Antwoorden per meetmoment
 * @param {number} props.totalResponses - Aantal invullingen (n)
 */
const OpenAnswersList = ({ groups, totalResponses }) => {
    const showMomentNames = groups.length > 1

    return (
        <div className="open-answers-list">
            <p className="chart-sample-size">n = {totalResponses}</p>
            {groups.map((group, groupIndex) => {
                const answers = group.items.filter(item => String(item.Input ?? '').trim() !== '')
                return (
                    <div key={`${group.position}-${groupIndex}`} className="open-answers-list-group">
                        {showMomentNames && <h3 className="open-answers-list-moment">{group.name}</h3>}
                        <ul>
                            {answers.map((item, index) => (
                                <li key={item.ID || item.docid || index}>{item.Input}</li>
                            ))}
                        </ul>
                    </div>
                )
            })}
        </div>
    )
}

export default OpenAnswersList
